const supplierMutations = {
  setUsers(state, users) {
    state.users = users;
  },

  setIsSupplier(state, isSupplier) {
    state.isSupplier = isSupplier;
  },

  setPublicSuppliers(state, suppliers) {
    state.publicSuppliers = suppliers;
  },

  setCustomersSuppliers(state, suppliers) {
    state.customersSuppliers = suppliers;
  },

  setSelectedSuppliers(state, suppliers) {
    state.selectedSuppliers = suppliers;
  },

  setSelectedFilters(state, filters) {
    state.selectedFilters = filters;
  },

  setRequestRunning(state, requestRunning) {
    state.requestRunning = requestRunning;
  },

  setTemporaryCombination(state, combinations) {
    state.temporaryCombinations = combinations;
  },

  addTemporaryCombination(state, combination) {
    state.temporaryCombinations = [...state.temporaryCombinations, combination];
  },

  removeTemporaryCombination(state, combination) {
    state.temporaryCombinations = state.temporaryCombinations.filter(c => c !== combination);
  },

  clearTemporaryCombinations(state) {
    state.temporaryCombinations = [];
  },

  setPricingConfigs(state, configs) {
    state.pricingConfigs = configs;
  },
};
export default supplierMutations;
